
import { useEffect, useState } from 'react';
import './App.css';
import { CharacterComponent } from './CharacterComponnet/CharacterComponent';

function App() {

  const [characters, setCharacters] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [searchedName, setSearchedName] = useState('')
  const iconUrl = "dragonballicon.png"

  function callApi(){
    //console.log("page", {currentPage})
    fetch(`https://dragonball-api.com/api/characters?page=${currentPage}`).
    then(res => res.json()).
    then(data => {
      //console.log(data)

      let arrayCharacters = []
      data.items.forEach(element => {
          arrayCharacters.push(element)
      });
      setCharacters(arrayCharacters)
    })
  }


  function callApiGetByName(){
    fetch(`https://dragonball-api.com/api/characters?name=${searchedName}`).
    then(response => response.json()).
    then(data => setCharacters(data)).
    catch(error => alert("Character not found"))
  }

  //useEffect to call api when page loads (page 1 default)
  useEffect(() => 
    {
      callApi()
    }, [])

    //useEffect each time currentPage changes, so it first changes the page and then calls the api
    //useState is async so it calls the api and then changes the page. Which is wrong
    useEffect(() => {
      callApi();
    }, [currentPage]);


    function handleSearch(e){
      e.preventDefault()
      if(searchedName.length > 0)
        {
          callApiGetByName()
        }
    }


  return (
    <div className='body-container'>

      <form className='search-bar' onSubmit={handleSearch}>
        <button type='button' className='btn-home' onClick={() => {setCurrentPage(1); callApi()}}>
          <img src={iconUrl}></img>
        </button>
        <input onChange={(e) => setSearchedName(e.target.value)} placeholder='Character name'></input>
        <button type='submit'>Search</button>
      </form>

      <div className='character-container'>
        {characters.map(element => {
          return(
            <CharacterComponent key={element.id} character= {element}></CharacterComponent>
          )
        })}
      </div>
      <div className='buttons-container'>
        
        <button onClick={() => { 
          if(currentPage > 1)
          {
            setCurrentPage(currentPage - 1)
            callApi()
          }}}> {"<<"} </button>

       
        <button id='current-page-label'> {currentPage} </button>
        
        <button onClick={() => { 
          if(currentPage < 6){
            setCurrentPage( currentPage + 1)
            callApi()
          }
        }}> {">>"} </button>
      
      </div>
    </div>
  );
}

export default App;
